import { render, staticRenderFns } from "./ProjectEditContext.vue?vue&type=template&id=2df443c8&"
import script from "./ProjectEditContext.vue?vue&type=script&lang=js&"
export * from "./ProjectEditContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports